if (!customElements.get('dropdown-link')) {
  class DropdownLink extends HTMLElement {
    static selectors = {
      head: '[js-dropdown-link-head]',
      body: '[js-dropdown-link-body]',
    };

    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();

      this.handleCloseRef = this.handleClose.bind(this);
    }

    handleToggle(event) {
      event.stopPropagation();

      this.classList.toggle(DropdownLink.ACTIVE_CLASS);
    }

    handleClose(event) {
      this.classList.remove(DropdownLink.ACTIVE_CLASS);
    }

    connectedCallback() {
      this.head = this.querySelector(DropdownLink.selectors.head);
      this.body = this.querySelector(DropdownLink.selectors.body);

      if (!this.head || !this.body) return;

      this.head.addEventListener('click', this.handleToggle.bind(this));

      document.body.addEventListener('click', this.handleCloseRef);
    }
  }

  customElements.define('dropdown-link', DropdownLink);
}
